import { render, staticRenderFns } from "./event_list.vue?vue&type=template&id=e5f01f80&scoped=true&"
import script from "./event_list.vue?vue&type=script&lang=js&"
export * from "./event_list.vue?vue&type=script&lang=js&"
import style0 from "./event_list.vue?vue&type=style&index=0&id=e5f01f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f01f80",
  null
  
)

export default component.exports